const removeRedundantEditionFacts = () => {
    document.querySelectorAll('.ff-home-festival-card-facts').forEach((facts) => {
        facts.querySelectorAll(':scope > span').forEach((fact) => {
            if (/^\d{4}\s+Edition$/u.test(fact.textContent?.trim() ?? '')) {
                fact.remove();
            }
        });

        if (!facts.querySelector(':scope > span')) {
            facts.remove();
        }
    });
};

if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', removeRedundantEditionFacts, { once: true });
} else {
    removeRedundantEditionFacts();
}
